import {
  prefixLanguage,
} from '@/utils/urls'

export const API_BASE_URL = prefixLanguage('/api/v1/')
export const prefixAPI = (url: string, model = ''): string => API_BASE_URL + model + url
